import { render, staticRenderFns } from "./DriverSwiping.vue?vue&type=template&id=3968f0cd&scoped=true&"
import script from "./DriverSwiping.vue?vue&type=script&lang=js&"
export * from "./DriverSwiping.vue?vue&type=script&lang=js&"
import style0 from "./DriverSwiping.vue?vue&type=style&index=0&id=3968f0cd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3968f0cd",
  null
  
)

export default component.exports